const jsonMap = new Map();

jsonMap.set('LRCL1', 'letter_recognition_level1');
jsonMap.set('LI', 'letter_intinsity');
jsonMap.set('LR1', 'letter_reading_level-1');
jsonMap.set('LR2', 'letter_reading_level-2');
jsonMap.set('RD', 'reading_dama');
jsonMap.set('RF', 'reading_fatha');
jsonMap.set('RK', 'reading_kasra');
jsonMap.set('SR1', 'sokon_level-1');
jsonMap.set('SR2', 'sokon_level-2');
jsonMap.set('LVA', 'long_vowels_aleef');
jsonMap.set('LVW', 'long_vowels_waaw');
jsonMap.set('LVY', 'long_vowels_yaa');
jsonMap.set('PRI1', 'printables_1');

//returns the JSON id
export const getJsonId = (id) => {
	if (!id) id = window.location.hash.slice(1);
	const jsonID = jsonMap.get(id);
	return jsonID;
};

//returns the fileId
export const getSheetId = function () {
	const id = window.location.hash.slice(1);
	return id;
};

//if the hash contains '-', it is a request for a pdf file, else it is a request for grid of files
export const isGridView = function () {
	return window.location.hash.indexOf('-') > 0 ? false : true;
};

export const getJsonData = async function (url) {
	try {
		// const res = await fetch(`../json/${jsonID}.json`);
		console.log(`URL To Fetch:${url}`);
		const res = await fetch(url);

		const data = await res.json();

		if (!res.ok) throw new Error(`${data.message} (${res.status})`);

		return data;
	} catch (err) {
		//If we just logged the error, the returned promise are going to be still fullfiled not rejected
		console.error(`${err}`);
		//To make the returned promise rejected, we need to rethrow the error
		//and handle it there, in the calling function
		throw err;
	}
};

//Used for Pagination, it calculates how many items displayed in the pagination component based on the window width
//Used by the controller in 2 places: 1. window resize event 2. init
export const calculatePageSize = function () {
	console.log(window.innerWidth);
	if (window.innerWidth <= 600) return 1;
	if (window.innerWidth <= 900) return 2;
	if (window.innerWidth > 900) return 3;
};
